import initialState from './initial_state';
import mutations from './mutations';

export default {
  state: initialState(),
  mutations,
};
